import { render, staticRenderFns } from "./settingEditComponent.vue?vue&type=template&id=56a834d4&"
import script from "./settingEditComponent.vue?vue&type=script&lang=ts&"
export * from "./settingEditComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports